import ExcelJS from 'exceljs'

export default {
  methods: {
    // ── EXCEL EXPORT ──────────────────────────────────────
    exportExcel() {
      const wb = new ExcelJS.Workbook()
      const ws = wb.addWorksheet('Machines & Tools')

      ws.columns = [
        { header: 'ID',                  key: 'id',                  width: 6  },
        { header: 'Name',                key: 'name',                width: 30 },
        { header: 'Serial Number',       key: 'serial_number',       width: 20 },
        { header: 'Model',               key: 'model',               width: 20 },
        { header: 'Type',                key: 'type',                width: 14 },
        { header: 'Status',              key: 'status',              width: 14 },
        { header: 'Purchase Date',       key: 'purchase_date',       width: 16 },
        { header: 'Warranty Expires At', key: 'warranty_expires_at', width: 20 },
        { header: 'Notes',               key: 'notes',               width: 40 },
      ]

      ws.pageSetup = {
          orientation:     'landscape',
          fitToPage:       true,
          fitToWidth:      1,
          fitToHeight:     0,
          paperSize:       9,
          margins: {
            left: 0.5, right: 0.5,
            top: 0.75, bottom: 0.75,
            header: 0.3, footer: 0.3
          }
        }

      ws.getRow(1).eachCell(cell => {
        cell.font      = { name: 'Calibri', bold: true, color: { argb: 'FF6B7280' }, size: 10 }
        cell.fill      = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F6F8' } }
        cell.border    = { bottom: { style: 'thin', color: { argb: 'FFE2E4EA' } } }
        cell.alignment = { vertical: 'middle', horizontal: 'left' }
      })

      this.filteredItems.forEach(item => {
        const row = ws.addRow({
          id:                  item.id,
          name:                item.name,
          serial_number:       item.serial_number || '—',
          model:               item.model || '—',
          type:                this.typeName(item.type),
          status:              this.statusName(item.status),
          purchase_date:       this.formatDate(item.purchase_date),
          warranty_expires_at: this.formatDate(item.warranty_expires_at),
          notes:               item.notes || '',
        })

        row.height = 18

        row.eachCell(cell => {
          cell.font      = { name: 'Calibri', size: 10, color: { argb: 'FF374151' } }
          cell.alignment = { vertical: 'middle' }
          cell.border    = { bottom: { style: 'hair', color: { argb: 'FFF0F1F4' } } }
        })

        const typeCell = row.getCell('type')
        typeCell.font = {
          name: 'Calibri', size: 10, bold: true,
          color: { argb: item.type === 1 ? 'FFF59E0B' : 'FF3B82F6' }
        }

        const statusColors = { 1: 'FF16A34A', 2: 'FF9CA3AF', 3: 'FFF59E0B', 4: 'FFEF4444' }
        row.getCell('status').font = {
          name: 'Calibri', size: 10, bold: true,
          color: { argb: statusColors[item.status] || 'FF374151' }
        }

        if (item.warranty_expires_at) {
          const diff = (new Date(item.warranty_expires_at) - new Date()) / 86400000
          if (diff < 0) {
            row.getCell('warranty_expires_at').font = { name: 'Calibri', size: 10, color: { argb: 'FFEF4444' } }
            row.getCell('warranty_expires_at').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFEF2F2' } }
          } else if (diff < 90) {
            row.getCell('warranty_expires_at').font = { name: 'Calibri', size: 10, color: { argb: 'FFF59E0B' } }
          }
        }

        if (item.deleted_at) {
          row.eachCell(cell => {
            cell.font = { name: 'Calibri', size: 10, color: { argb: 'FF9CA3AF' }, strike: true }
          })
        }
      })

      wb.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url  = URL.createObjectURL(blob)
        const a    = document.createElement('a')
        a.href     = url
        a.download = `machines_tools_${new Date().toISOString().slice(0,10)}.xlsx`
        a.click()
        URL.revokeObjectURL(url)
      })
    },

    // ── PRINT ─────────────────────────────────────────────
    openPrintDialog() {
      this.printDialog = true
    },

    printNow() {
      const printContents = this.$refs.printView?.$el?.innerHTML
      if (!printContents) return
        
      const win = window.open('', '_blank')
      win.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <title>Machines & Tools</title>
          <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap" rel="stylesheet">
            <style scoped>
            @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap');

            .inv-print-view {
              font-family: 'IBM Plex Sans', sans-serif;
              font-size: 11px;
              color: #111827;
              background: #fff;
              padding: 28px 32px;
              min-width: 900px;
            }

            /* ── HEADER ── */
            .inv-print-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-bottom: 14px;
              padding-bottom: 14px;
              border-bottom: 2px solid #111827;
            }
            .inv-print-title {
              font-family: 'IBM Plex Mono', monospace;
              font-size: 18px;
              font-weight: 700;
              letter-spacing: 0.12em;
              color: #111827;
            }
            .inv-print-meta {
              font-family: 'IBM Plex Mono', monospace;
              font-size: 9px;
              color: #6b7280;
              margin-top: 5px;
              letter-spacing: 0.05em;
            }
            .inv-print-header__right { text-align: right; }
            .inv-print-logo {
              font-family: 'IBM Plex Mono', monospace;
              font-size: 13px;
              font-weight: 700;
              letter-spacing: 0.2em;
              color: #374151;
            }
            .inv-print-logo-sub {
              font-family: 'IBM Plex Mono', monospace;
              font-size: 8px;
              color: #9ca3af;
              letter-spacing: 0.1em;
              margin-top: 3px;
            }

            /* ── SUMMARY ── */
            .inv-print-summary {
              display: flex;
              align-items: center;
              gap: 16px;
              margin-bottom: 14px;
              padding: 8px 12px;
              background: #f5f6f8;
              border: 1px solid #e2e4ea;
              font-family: 'IBM Plex Mono', monospace;
              font-size: 10px;
              color: #6b7280;
              letter-spacing: 0.05em;
            }
            .inv-print-summary-item { display: flex; align-items: center; gap: 5px; }
            .inv-print-summary-num  { font-weight: 700; color: #111827; font-size: 13px; }
            .inv-print-summary-sep  { color: #d1d5db; margin: 0 4px; }

            /* ── TABLE ── */
            .inv-print-table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
            }
            .col-id       { width: 40px; }
            .col-name     { width: 18%; }
            .col-serial   { width: 13%; }
            .col-model    { width: 11%; }
            .col-type     { width: 9%;  }
            .col-status   { width: 9%;  }
            .col-date     { width: 10%; }
            .col-warranty { width: 10%; }
            .col-notes    { width: auto; }

            .inv-print-table thead tr { border-bottom: 2px solid #e2e4ea; }
            .inv-print-table th {
              font-family: 'IBM Plex Mono', monospace;
              font-size: 8px; font-weight: 700; letter-spacing: 0.12em;
              color: #6b7280; padding: 7px 8px; text-align: left;
              background: #f5f6f8; white-space: nowrap;
            }
            .inv-print-table td {
              padding: 6px 8px;
              border-bottom: 1px solid #f0f1f4;
              vertical-align: top;
              color: #374151;
              line-height: 1.4;
            }
            .inv-print-tr--even td    { background: #fafafa; }
            .inv-print-tr--deleted td { opacity: 0.35; text-decoration: line-through; }

            .inv-print-name        { font-weight: 600; color: #111827; font-size: 11px; }
            .inv-print-td--mono    { font-family: 'IBM Plex Mono', monospace; font-size: 9px; }
            .inv-print-td--dim     { color: #9ca3af; }
            .inv-print-td--notes   { font-size: 9px; color: #6b7280; }
            .inv-print-td--expired { color: #ef4444 !important; font-weight: 600; }
            .inv-print-td--soon    { color: #f59e0b !important; }
            .inv-print-empty {
              text-align: center; padding: 32px;
              color: #9ca3af; font-family: 'IBM Plex Mono', monospace;
              font-size: 10px; letter-spacing: 0.1em;
            }

            /* ── BADGES ── */
            .inv-print-badge {
              font-family: 'IBM Plex Mono', monospace;
              font-size: 8px; font-weight: 700; letter-spacing: 0.06em;
              padding: 2px 6px; border: 1px solid; display: inline-block;
            }
            .inv-print-badge--type-1 { color: #f59e0b; border-color: #f59e0b; background: rgba(245,158,11,0.06); }
            .inv-print-badge--type-2 { color: #3b82f6; border-color: #3b82f6; background: rgba(59,130,246,0.06); }

            /* ── STATUS ── */
            .inv-print-status {
              font-family: 'IBM Plex Mono', monospace;
              font-size: 9px; font-weight: 700; letter-spacing: 0.05em;
            }
            .inv-print-status--1 { color: #16a34a; }
            .inv-print-status--2 { color: #9ca3af; }
            .inv-print-status--3 { color: #f59e0b; }
            .inv-print-status--4 { color: #ef4444; }

            /* ── FOOTER ── */
            .inv-print-footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 16px;
              padding-top: 10px;
              border-top: 1px solid #e2e4ea;
              font-family: 'IBM Plex Mono', monospace;
              font-size: 9px;
              color: #9ca3af;
              letter-spacing: 0.05em;
            }
            .inv-print-legend         { font-size: 11px; }
            .inv-print-legend--expired { color: #ef4444; }
            .inv-print-legend--soon    { color: #f59e0b; }

            /* ── PRINT MEDIA ── */
            @media print {
              .inv-print-view {padding: 0;min-width: unset;}
              .inv-print-title   { font-size: 14px; }
              .inv-print-summary { padding: 6px 10px; font-size: 9px; }
              .inv-print-table th { font-size: 7px; padding: 5px 6px; }
              .inv-print-table td { padding: 5px 6px; font-size: 9px; }
              thead { display: table-header-group; }
              tr    { page-break-inside: avoid; }
              @page { margin: 1.5cm; size: A4 landscape; }
            }
            </style>
        </head>
        <body>
          ${printContents}
        </body>
        </html>
      `)
      win.document.close()
      win.focus()
      setTimeout(() => { win.print(); win.close() }, 800)
    },

    getPrintStyles() {
      return `
        .inv-print-view { padding: 24px 28px; }
        .inv-print-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 2px solid #111827; }
        .inv-print-title { font-family: 'IBM Plex Mono', monospace; font-size: 16px; font-weight: 700; letter-spacing: 0.12em; }
        .inv-print-meta { font-family: 'IBM Plex Mono', monospace; font-size: 9px; color: #6b7280; margin-top: 4px; letter-spacing: 0.06em; }
        .inv-print-logo { font-family: 'IBM Plex Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.2em; color: #9ca3af; }
        .inv-print-table { width: 100%; border-collapse: collapse; font-size: 10px; }
        .inv-print-table th { font-family: 'IBM Plex Mono', monospace; font-size: 8px; font-weight: 700; letter-spacing: 0.1em; color: #6b7280; padding: 6px 8px; text-align: left; border-bottom: 1px solid #e2e4ea; background: #f5f6f8; white-space: nowrap; }
        .inv-print-table td { padding: 6px 8px; border-bottom: 1px solid #f0f1f4; vertical-align: top; color: #374151; }
        .inv-print-tr--deleted td { opacity: 0.4; text-decoration: line-through; }
        .inv-print-td--id { font-family: 'IBM Plex Mono', monospace; color: #9ca3af; width: 36px; }
        .inv-print-td--mono { font-family: 'IBM Plex Mono', monospace; font-size: 9px; }
        .inv-print-td--name strong { font-weight: 600; color: #111827; }
        .inv-print-sub { color: #9ca3af; font-size: 9px; }
        .inv-print-td--notes { max-width: 140px; font-size: 9px; color: #6b7280; }
        .inv-print-td--expired { color: #ef4444; }
        .inv-print-td--soon { color: #f59e0b; }
        .inv-print-badge { font-family: 'IBM Plex Mono', monospace; font-size: 8px; font-weight: 700; letter-spacing: 0.06em; padding: 1px 5px; border: 1px solid; }
        .inv-print-badge[data-type="1"] { color: #f59e0b; border-color: #f59e0b; }
        .inv-print-badge[data-type="2"] { color: #3b82f6; border-color: #3b82f6; }
        .inv-print-status { font-family: 'IBM Plex Mono', monospace; font-size: 8px; font-weight: 700; letter-spacing: 0.06em; }
        .inv-print-status[data-status="1"] { color: #16a34a; }
        .inv-print-status[data-status="2"] { color: #9ca3af; }
        .inv-print-status[data-status="3"] { color: #f59e0b; }
        .inv-print-status[data-status="4"] { color: #ef4444; }
        .inv-print-footer { display: flex; justify-content: space-between; margin-top: 16px; padding-top: 8px; border-top: 1px solid #e2e4ea; font-family: 'IBM Plex Mono', monospace; font-size: 9px; color: #9ca3af; }
        @page { margin: 1.5cm; size: A4 landscape; }
      `
    },
  },
}